import React, { useEffect, useState }       from 'react';
import { useLocation, useNavigate }         from 'react-router-dom';
import Logo                                 from '../images/logo_bianco_intero.png';
import iconSpain                            from '../images/icon-spain.svg'
import iconItaly                            from '../images/icon-italy.svg'
import iconUK                               from '../images/icon-uk.svg'
import ExitToAppIcon                        from '@mui/icons-material/ExitToApp';
import InventoryIcon                        from '@mui/icons-material/Inventory';
import NotificationsIcon                    from '@mui/icons-material/Notifications';
import AccountBoxIcon                       from '@mui/icons-material/AccountBox';
import LogoutModal                          from './modal/LogoutModal';
import DashboardIcon                        from '@mui/icons-material/Dashboard';
import ChatIcon                             from '@mui/icons-material/Chat';
import AuthService                          from './service/AuthService';
import { useAvvisi }                        from '../context/AvvisiContext';
import { useTranslation }                   from 'react-i18next';
import DoneAllIcon                          from '@mui/icons-material/DoneAll';
import { Close }                            from '@mui/icons-material';
import { GridMenuIcon }                     from '@mui/x-data-grid';
import ContactSupportIcon                   from '@mui/icons-material/ContactSupport';
import SendEmail                            from './SendEmail';
import {
    AppBar,
    Toolbar,
    Tabs,
    Tab,
    Box,
    Select,
    MenuItem,
    Divider,
    Tooltip,
    Badge,
    Popover,
    List,
    ListItem,
    ListItemText,
    Drawer,
    IconButton,
    Button,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Snackbar,
    Alert
} from '@mui/material';

const NavBar = () => {
    const { i18n, t } = useTranslation();

    const languageMap = {
            it: 'it',
            es: 'es',
            en: 'en',
    };

    const getFrontendLanguage   = (backendLanguage)  => languageMap[backendLanguage ];
    const getBackendLanguage    = (frontendLanguage) => languageMap[frontendLanguage];

    const navigate = useNavigate();
    const location = useLocation();
    const { datiAvvisi, markAllAsRead, readReso } = useAvvisi();

    const user = AuthService.getCurrentUser();
    const userRoles = user.roles[0];
    const isCliente = userRoles;

    const [selectedTab,                 setSelectedTab              ] = useState(0);
    const [modalOpen,                   setModalOpen                ] = useState(false);
    const [anchorEl,                    setAnchorEl                 ] = useState(null);
    const [confirmMarkAllDialogOpen,    setConfirmMarkAllDialogOpen ] = useState(false);
    const [confirmReadDialogOpen,       setConfirmReadDialogOpen    ] = useState(false);
    const [selectedAvvisoId,            setSelectedAvvisoId         ] = useState(null);
    const [drawerOpen,                  setDrawerOpen               ] = useState(false);
    const [openSupportDialog,           setOpenSupportDialog        ] = useState(false);
    const [message,                     setMessage                  ] = useState('');
    const [snackbarSeverity,            setSnackbarSeverity         ] = useState('success');
    const [openSnackbar,                setOpenSnackbar             ] = useState(false);






    const [language, setLanguage] = useState(() => {
        const storedUser = JSON.parse(sessionStorage.getItem('user'));
        const initialLanguage = storedUser?.lingua || 'es'; 
        i18n.changeLanguage(initialLanguage.toLowerCase()); 
        return initialLanguage;
    });


    useEffect(() => {
        const storedUser = JSON.parse(sessionStorage.getItem('user'));
        if (storedUser?.lingua) {
            i18n.changeLanguage(storedUser.lingua.toLowerCase());
        }
    }, []);
    
    

    useEffect(() => {
        if (language) {
            const storedUser = JSON.parse(sessionStorage.getItem('user'));
            if (storedUser) {
                storedUser.lingua = getBackendLanguage(language);
                sessionStorage.setItem('user', JSON.stringify(storedUser));
            }
        }
    }, [language]);

    const handleLanguageChange = (event) => {
        const selectedLang = event.target.value;
        setLanguage(selectedLang);
        i18n.changeLanguage(selectedLang, (err, t) => {
            if (err) return console.error("Errore cambiando lingua", err);
        });
        const storedUser = JSON.parse(sessionStorage.getItem('user'));
        if (storedUser) {
            storedUser.lingua = selectedLang;
            sessionStorage.setItem('user', JSON.stringify(storedUser)); 
        }
    };
    

    const handleModalLogout = () => {
        setModalOpen(true);
    };

    const handleConfirmLogout = () => {
        sessionStorage.clear();
        navigate("/login", { replace: true });
        return null;
    };

    const handleTabChange = (e, newValue) => {
        setSelectedTab(newValue);

        switch (userRoles) {
            case 'CLIENTE':
                handleClienteTabs(newValue, e);
                break;
            case 'SAT':
                handleSatTabs(newValue, e);
                break;
            default:
                handleDefaultTabs(newValue, e);
                break;
        }
    };

    const handleClienteTabs = (tabIndex, eventObj) => {
        switch (tabIndex) {
            case 0:
                navigate('/resi', { replace: true });
                break;
            case 1:
                navigate('/profilo');
                break;
            case 2:
                navigate('/chat1', { replace: true });
                break;
            case 3:
                setAnchorEl(eventObj.currentTarget);
                break;
            case 4: 
                setOpenSupportDialog(true);            
                break;
            default:
                setAnchorEl(null);
                break;
        }
    };

    const handleSatTabs = (tabIndex, eventObj) => {
        setSelectedTab(tabIndex);
        switch (tabIndex) {
            case 0:
                navigate('/dashboard', { replace: true });
                break;
            case 1:
                navigate('/chat');
                break;
            case 2:
                setAnchorEl(eventObj.currentTarget);
                break;
            default:
                setAnchorEl(null);
                break;
        }
    };

    const handleDefaultTabs = (tabIndex, eventObj) => {
        switch (tabIndex) {
            case 0:
                navigate('/dashboard', { replace: true });
                break;
            case 1:
                navigate('/profilo');
                break;
            case 2:
                navigate('/chat');
                break;
            case 3:
                setAnchorEl(eventObj.currentTarget);
                break;
            default:
                setAnchorEl(null);
                break;
        }
    };

    const handleNavigateDashboard = () => {
        navigate("/dashboard")
    }

    const handleNavigateResi = () => {
        navigate("/resi")
    }

    const handleClosePopover = () => {
        setAnchorEl(null);
        setSelectedTab(null);
    };

    const handleDrawerToggle = () => {
        setDrawerOpen(!drawerOpen);
    };


    useEffect(() => {
        switch (location.pathname) {
            case '/resi':
                setSelectedTab(0);
                break;
            case '/profilo':
                setSelectedTab(1);
                break;
            case '/chat':
                setSelectedTab(userRoles === 'CLIENTE' ? 2 : 1);
                break;
            case '/chat1':
                setSelectedTab(userRoles === 'CLIENTE' ? 2 : 6);
                break;
            case '/dashboard':
                setSelectedTab(userRoles === 'CLIENTE' ? 5 : 0);
                break;
            default:
                setSelectedTab(false);
                break;
        }
    }, [location.pathname, userRoles]);


    const openConfirmMarkAllDialog  = () => setConfirmMarkAllDialogOpen(true);
    const closeConfirmMarkAllDialog = () => setConfirmMarkAllDialogOpen(false);

    const openConfirmReadDialog = (idAvviso, descrizione) => {
        setSelectedAvvisoId(idAvviso);
        if (descrizione.toLowerCase().includes("integrazione")) {
            // Apri un altro modale specifico per le richieste di integrazione
            openIntegrationModal(idAvviso);
        } else {
            setConfirmReadDialogOpen(true);
        }    
    };
    const closeConfirmReadDialog = () => setConfirmReadDialogOpen(false);
    const closeSupportDialog = () => setOpenSupportDialog(false);


    const openIntegrationModal = (idAvviso) => {
        // console.log(`Apri il modale per la richiesta di integrazione: ${idAvviso}`);
    };
    

    // Funzione per marcare tutti gli avvisi come letti dopo la conferma
    const handleConfirmMarkAllAsRead = () => {
        markAllAsRead();
        closeConfirmMarkAllDialog();
    };

    // Funzione per marcare un singolo avviso come letto dopo la conferma
    const handleConfirmReadAvviso = () => {
        if (selectedAvvisoId !== null) {
            readReso(selectedAvvisoId);
        }
        closeConfirmReadDialog();
    };

    // Funzione per inviare la mail per il supporto tecnico
    const handleSendEmailSupport = () => {
        const idReso          = null;
        const destinatario    = null;
        const idDestinatario  = 1;
        const messaggio       = null;

         // Invio email
    // SendEmail(
    //     idReso,
    //     destinatario,
    //     messaggio,
    //     'EMAIL_SUPPORTO',
        
    //     () => {
    //         setMessage(t('Email inviata con successo! vi contatteremo al più presto!'));
    //         setSnackbarSeverity('success');
    //         setOpenSnackbar(true);
    //     },
    //     () => {
    //         setMessage(t("Errore nell'invio dell'email. Per favore, riprova."));
    //         setSnackbarSeverity('error');
    //         setOpenSnackbar(true);
    //     }
    // );

    };

     const languageOptions = [
        { value: 'it', label: 'it', flag: iconItaly },
        { value: 'es', label: 'es', flag: iconSpain },
        { value: 'en', label: 'en', flag: iconUK    },
    ];

    const handleCloseSnackbar = () => {
        setOpenSnackbar(false);
    };

    return (
        <>
            <AppBar position="static"
                sx={{
                    backgroundImage: 'linear-gradient(90deg, #28334B 0%, #213d72 100%)',
                    boxShadow: '0px 6px 20px rgba(0, 0, 0, 0.4)',
                }}>
                <Toolbar sx={{ justifyContent: 'space-between' }}>
                    <Box display="flex" alignItems="center">
                        <IconButton onClick={isCliente === 'CLIENTE' ? handleNavigateResi : handleNavigateDashboard}>
                            <img src={Logo} alt="Riba Mundo Logo" style={{ width: 150 }} />
                        </IconButton>
                    </Box>



                    <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 2, md: 4 } }} >
                        { /* TAB PER IL CLIENTE */}
                        {userRoles === 'CLIENTE' && (
                            <Tabs
                                value={selectedTab}
                                onChange={handleTabChange}
                                textColor="inherit"
                                indicatorColor="none"
                                sx={{ minHeight: 48 }}
                            >
                                <Tab
                                    icon={<InventoryIcon sx={{ m: 'auto' }} />}
                                    label={t("Resi")}
                                    sx={{
                                        py: 2,
                                        px: 3,
                                        minHeight: 48,
                                        backgroundColor: selectedTab === 0 ? '#FDA03D' : 'transparent',
                                        color: 'white',
                                        display: { xs: 'none', md: 'block' },
                                        '&:hover': {
                                            backgroundColor: selectedTab === 0 ? '#FDA03D' : 'rgba(255, 255, 255, 0.1)',
                                        },
                                        '& .MuiTab-iconWrapper': {
                                            display: 'block',
                                        },
                                    }}
                                />
                                <Tab
                                    icon={<AccountBoxIcon sx={{ m: 'auto' }} />}
                                    label={t("Profilo")}
                                    sx={{
                                        px: 3,
                                        minHeight: 48,
                                        backgroundColor: selectedTab === 1 ? '#FDA03D' : 'transparent',
                                        color: 'white',
                                        display: { xs: 'none', md: 'block' },
                                        '&:hover': {
                                            backgroundColor: selectedTab === 1 ? '#FDA03D' : 'rgba(255, 255, 255, 0.1)',
                                        },
                                        '& .MuiTab-iconWrapper': {
                                            display: 'block',
                                        },

                                    }}
                                />
                                <Tab
                                    icon={<ChatIcon sx={{ m: 'auto' }} />}
                                    label={t("Chat")}
                                    sx={{
                                        px: 3,
                                        minHeight: 48,
                                        backgroundColor: selectedTab === 2 ? '#FDA03D' : 'transparent',
                                        color: 'white',
                                        display: { xs: 'none', md: 'block' },
                                        '&:hover': {
                                            backgroundColor: selectedTab === 2 ? '#FDA03D' : 'rgba(255, 255, 255, 0.1)',
                                        },
                                        '& .MuiTab-iconWrapper': {
                                            display: 'block',
                                        },

                                    }}
                                />
                                <Tab
                                    icon={
                                        <Badge
                                            badgeContent={datiAvvisi.length}
                                            color="error"
                                            invisible={datiAvvisi.length === 0}
                                        >
                                            <NotificationsIcon />
                                        </Badge>
                                    }
                                    label={t("Avvisi")}
                                    sx={{
                                        px: 3,
                                        minHeight: 48,
                                        backgroundColor: selectedTab === 3 ? '#FDA03D' : 'transparent',
                                        color: 'white',
                                        '&:hover': {
                                            backgroundColor: selectedTab === 3 ? '#FDA03D' : 'rgba(255, 255, 255, 0.1)',
                                        },
                                        '& .MuiTab-iconWrapper': {
                                            display: 'block',
                                        },
                                    }}
                                />
                                <Tab
                                    icon={
                                            <ContactSupportIcon />
                                    }
                                    label={t("Assistenza")}
                                    sx={{
                                        px: 3,
                                        minHeight: 48,
                                        backgroundColor: selectedTab === 4 ? '#FDA03D' : 'transparent',
                                        color: 'white',
                                        '&:hover': {
                                            backgroundColor: selectedTab === 4 ? '#FDA03D' : 'rgba(255, 255, 255, 0.1)',
                                        },
                                        '& .MuiTab-iconWrapper': {
                                            display: 'block',
                                        },
                                    }}
                                />
                            </Tabs>
                        )}

                        {/* Tabs per il ruolo SAT */}
                        {userRoles === 'SAT' && (
                            <Tabs
                                value={selectedTab}
                                onChange={handleTabChange}
                                textColor="inherit"
                                indicatorColor="none"
                                sx={{ minHeight: 48 }}
                            >
                                <Tab
                                    icon={<DashboardIcon sx={{ m: 'auto' }} />}
                                    label={t("Dashboard")}
                                    sx={{
                                        py: 2,
                                        px: 3,
                                        minHeight: 48,
                                        backgroundColor: selectedTab === 0 ? '#FDA03D' : 'transparent',
                                        color: 'white',
                                        display: { xs: 'none', md: 'block' },
                                        '&:hover': {
                                            backgroundColor: selectedTab === 0 ? '#FDA03D' : 'rgba(255, 255, 255, 0.1)',
                                        },
                                        '& .MuiTab-iconWrapper': {
                                            display: 'block',
                                        },

                                    }}
                                />
                                <Tab
                                    icon={<ChatIcon sx={{ m: 'auto' }} />}
                                    label={t("Chat")}
                                    sx={{
                                        px: 3,
                                        minHeight: 48,
                                        backgroundColor: selectedTab === 1 ? '#FDA03D' : 'transparent',
                                        color: 'white',
                                        display: { xs: 'none', md: 'block' },
                                        '&:hover': {
                                            backgroundColor: selectedTab === 1 ? '#FDA03D' : 'rgba(255, 255, 255, 0.1)',
                                        },
                                        '& .MuiTab-iconWrapper': {
                                            display: 'block',
                                        },

                                    }}
                                />
                                <Tab
                                    icon={
                                        <Badge
                                            badgeContent={datiAvvisi.length}
                                            color="error"
                                            invisible={datiAvvisi.length === 0}
                                        >
                                            <NotificationsIcon sx={{ m: 'auto' }} />
                                        </Badge>
                                    }
                                    label={t("Avvisi")}
                                    sx={{
                                        px: 3,
                                        minHeight: 48,
                                        backgroundColor: selectedTab === 2 ? '#FDA03D' : 'transparent',
                                        color: 'white',
                                        '&:hover': {
                                            backgroundColor: selectedTab === 2 ? '#FDA03D' : 'rgba(255, 255, 255, 0.1)',
                                        },
                                        '& .MuiTab-iconWrapper': {
                                            display: 'block',
                                        },
                                    }}
                                />
                            </Tabs>
                        )}

                        {/* Divider e selezione della lingua */}
                        <Divider
                            orientation="vertical"
                            flexItem
                            sx={{ display: { xs: 'none', md: 'block' }, bgcolor: 'white', mx: 0, height: '60px', mt: 1 }}
                        />

                        <Select
                            value={language}
                            onChange={handleLanguageChange}
                            renderValue={(selected) => {
                                const selectedLang = languageOptions.find(lang => lang.value === selected);
                                return (
                                    <Box display="flex" alignItems="center">
                                        <img src={selectedLang?.flag} alt={`${selectedLang?.label} flag`} style={{ width: '24px', marginRight: '8px' }} />
                                        {selectedLang.label}
                                    </Box>
                                );
                            }}
                            displayEmpty
                            inputProps={{ 'aria-label': 'Select Language' }}
                            sx={{
                                color: 'white',
                                border: 'none',
                                boxShadow: 'none',
                                display: { xs: 'none', md: 'block' },
                                '& fieldset': { border: 'none' },
                                '&:hover': {
                                    border: '1px solid white',
                                },
                                '.MuiSelect-icon': { color: 'white' },
                            }}
                        >
                            {languageOptions.map((lang) => (
                                <MenuItem key={lang?.value} value={lang?.value}>
                                    <Box display="flex" alignItems="center">
                                        <img src={lang?.flag} alt={`${lang?.label} flag`} style={{ width: '24px', marginRight: '8px' }} />
                                        {lang?.label}
                                    </Box>
                                </MenuItem>
                            ))}
                        </Select>

                        <Tooltip title="Logout">
                            <Box
                                sx={{
                                    py: 2,
                                    px: 3,
                                    minHeight: 48,
                                    backgroundColor: modalOpen ? '#FDA03D' : 'transparent',
                                    color: 'white',
                                    display: { xs: 'none', md: 'flex' },
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    '&:hover': {
                                        backgroundColor: '#FDA03D',
                                    },
                                    cursor: 'pointer',
                                }}
                                onClick={handleModalLogout}
                            >
                                <ExitToAppIcon sx={{ width: '25px', height: '25px' }} />
                            </Box>
                        </Tooltip>

                        <LogoutModal
                            open={modalOpen}
                            onClose={() => setModalOpen(false)}
                            onConfirm={handleConfirmLogout}
                        />

                        <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                            <IconButton onClick={handleDrawerToggle} >
                                <GridMenuIcon sx={{ color: 'white' }} />
                            </IconButton>
                        </Box>
                    </Box>

                    <Popover
                        open={Boolean(anchorEl)}
                        anchorEl={anchorEl}
                        onClose={handleClosePopover}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        PaperProps={{
                            style: { width: '300px', maxHeight: '300px' },
                        }}
                    >
                        {/* Icona per segnare tutti come letti */}
                        {userRoles === 'CLIENTE' && (
                            <>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 16px' }}>
                                    <Typography variant="h6" sx={{ color: '#FDA03D', fontWeight: 'bold'}}>{t("Avvisi")}</Typography>
                                    <IconButton onClick={openConfirmMarkAllDialog} disabled={datiAvvisi.length === 0}>
                                        <DoneAllIcon sx={{ color: datiAvvisi.length === 0 ? '#b0bec5' : '#263F78' }} />
                                    </IconButton>
                                </Box>
                                <List sx={{ overflowY: 'auto', maxHeight: '300px' }}>
                                    {datiAvvisi.length === 0 ? (
                                        <ListItem>
                                            <ListItemText primary={t("Non hai avvisi")} />
                                        </ListItem>
                                    ) : (
                                        datiAvvisi.map((avviso) => (
                                            <ListItem button key={avviso.id} onClick={() => openConfirmReadDialog(avviso.id, avviso.testi[0]?.descrizione)}>
                                                <ListItemText sx={{ color: '#263F78', fontWeight: 'bold'}} primary="SAT" secondary={avviso.testi[0]?.descrizione} />
                                            </ListItem>
                                        ))
                                    )}
                                </List>
                            </>
                        )}
                        {userRoles === 'SAT' && (
                            <>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 16px' }}>
                                    <Typography variant="h6" sx={{ color: '#FDA03D', fontWeight: 'bold'}}>{t("Avvisi")}</Typography>
                                    <IconButton onClick={openConfirmMarkAllDialog} disabled={datiAvvisi.length === 0}>
                                        <DoneAllIcon sx={{ color: datiAvvisi.length === 0 ? '#b0bec5' : '#263F78' }} />
                                    </IconButton>
                                </Box>
                                <List sx={{ overflowY: 'auto', maxHeight: '300px' }}>
                                    {datiAvvisi.length === 0 ? (
                                        <ListItem>
                                            <ListItemText primary={t("Non hai avvisi")} />
                                        </ListItem>
                                    ) : (
                                        datiAvvisi.map((avviso, index) => (
                                            <React.Fragment key={avviso.id}>
                                                <ListItem button onClick={() => openConfirmReadDialog(avviso.id)}>
                                                    <ListItemText 
                                                        sx={{ color: '#263F78', fontWeight: 'bold' }} 
                                                        primary={avviso.testi[0]?.idDestinatario} 
                                                        secondary={avviso.testi[0]?.descrizione} 
                                                    />
                                                </ListItem>
                                                {index < datiAvvisi.length - 1 && <Divider />}
                                            </React.Fragment>
                                        ))
                                    )}
                                </List>
                            </>
                        )}
                    </Popover>

                </Toolbar>
            </AppBar>


            <Drawer
                anchor="left"
                open={drawerOpen}
                onClose={handleDrawerToggle}
                sx={{ display: { xs: 'block', md: 'none' } }}
            >
                <Box
                    sx={{
                        width: 250,
                        backgroundColor: '#213d72',
                        height: '100%',
                        color: 'white',
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundImage: 'linear-gradient(90deg, #28334B 0%, #213d72 100%)'
                    }}
                    role="presentation"
                    onClick={handleDrawerToggle}
                    onKeyDown={handleDrawerToggle}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px' }}>
                        <Typography variant="h6" sx={{ color: 'white' }}>
                            {t('Menu')}
                        </Typography>
                        <Button
                            onClick={handleDrawerToggle}
                            sx={{
                                minWidth: 'auto',
                                padding: '0',
                                color: '#CCCCCC',
                            }}
                        >
                            <Close
                                sx={{
                                    color: '#CCCCCC',
                                    '&:hover': {
                                        color: '#FDA03D',
                                    },
                                }}
                            />
                        </Button>
                    </Box>

                    <List onChange={handleTabChange}>
                        {/* Codice per gli elementi del Drawer */}
                        {userRoles === 'CLIENTE' && (
                            <>
                                <ListItem button onClick={(e) => handleTabChange(e, 0)}>
                                    <InventoryIcon />
                                    <ListItemText primary={t("Resi")} sx={{ mx: 1 }} />
                                </ListItem>
                                <ListItem button onClick={(e) => handleTabChange(e, 1)}>
                                    <AccountBoxIcon />
                                    <ListItemText primary={t("Profilo")} sx={{ mx: 1 }} />
                                </ListItem>
                                <ListItem button onClick={(e) => handleTabChange(e, 2)}>
                                    <ChatIcon />
                                    <ListItemText primary={t("Chat")} sx={{ mx: 1 }} />
                                </ListItem>
                            </>
                        )}
                        {userRoles === 'SAT' && (
                            <>
                                <ListItem button onClick={(e) => handleTabChange(e, 0)}>
                                    <DashboardIcon />
                                    <ListItemText primary={t("Dashboard")} sx={{ mx: 1 }} />
                                </ListItem>
                                <ListItem button onClick={(e) => handleTabChange(e, 1)}>
                                    <ChatIcon />
                                    <ListItemText primary={t("Chat")} sx={{ mx: 1 }} />
                                </ListItem>
                            </>
                        )}
                        <Divider sx={{ my: 2, bgcolor: 'rgba(255,255,255,0.3)' }} />
                        <ListItem button sx={{ m: 0, p: 1 }}>
                            <Select
                                value={language}
                                onChange={handleLanguageChange}
                                renderValue={(selected) => {
                                    const selectedLang = languageOptions.find(lang => lang?.value === selected);
                                    return (
                                        <Box display="flex" alignItems="center">
                                            <img src={selectedLang?.flag} alt={`${selectedLang?.label} flag`} style={{ width: '24px', marginRight: '8px' }} />
                                            {selectedLang?.label}
                                        </Box>
                                    );
                                }}
                                displayEmpty
                                inputProps={{ 'aria-label': 'Select Language' }}
                                sx={{
                                    color: 'white',
                                    border: 'none',
                                    boxShadow: 'none',
                                    '& fieldset': { border: 'none' },
                                    '.MuiSelect-icon': { color: 'white' },
                                }}
                            >
                                {languageOptions.map((lang) => (
                                    <MenuItem key={lang?.value} value={lang?.value}>
                                        <Box display="flex" alignItems="center">
                                            <img src={lang?.flag} alt={`${lang?.label} flag`} style={{ width: '24px', marginRight: '8px' }} />
                                            {lang?.label}
                                        </Box>
                                    </MenuItem>
                                ))}
                            </Select>
                        </ListItem>
                        <ListItem button>
                            <ExitToAppIcon />
                            <ListItemText primary={t("Logout")} onClick={handleModalLogout} sx={{ mx: 1 }} />
                        </ListItem>
                    </List>
                </Box>
            </Drawer>

            <Dialog
                open={confirmMarkAllDialogOpen}
                onClose={closeConfirmMarkAllDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle sx={{ fontWeight: 'bold', color: '#263F78', textAlign: 'center'}}>{t('Conferma')}Conferma</DialogTitle>
                <DialogContent sx={{ display: 'flex', justifyContent: 'center'}}>
                    <DialogContentText sx={{ textAlign: 'center'}}>{t('Sei sicuro di voler segnare tutti gli avvisi come letti?')}</DialogContentText>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'center', mb: 2}}>
                    <Button onClick={closeConfirmMarkAllDialog}
                    variant="contained"
                    sx={{
                        borderRadius: '10px',
                        width: '10em',
                        backgroundColor: "#b0bec5", 
                        color: "#ffffff", 
                        "&:hover": {
                            transform: "scale(1.05)",
                            backgroundColor: "#90a4ae",
                        },
                    }}
                    >
                        Annulla
                    </Button>
                    <Button onClick={handleConfirmMarkAllAsRead}
                    variant="contained"
                    sx={{
                        borderRadius: '10px',
                        width: '10em',
                        backgroundColor: "#213d72", 
                        color: "#ffffff", 
                        "&:hover": {
                            backgroundColor: "#1a315b", 
                            transform: "scale(1.05)",
                        },
                    }}
                    autoFocus
                        >
                            Conferma
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Dialog di conferma per leggere un singolo avviso */}
            <Dialog
                open={confirmReadDialogOpen}
                onClose={closeConfirmReadDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle sx={{ fontWeight: 'bold', color: '#263F78', textAlign: 'center'}}>Conferma</DialogTitle>
                    <DialogContent sx={{ display: 'flex', justifyContent: 'center' }}>
                        <DialogContentText sx={{ textAlign: 'center'}}>{t('Sei sicuro di voler segnare questo avviso come letto?')}</DialogContentText>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'center', mb:2}}>
                    <Button onClick={closeConfirmReadDialog}
                    variant="contained"
                    sx={{
                        borderRadius: '10px',
                        width: '10em',
                        backgroundColor: "#b0bec5", 
                        color: "#ffffff", 
                        "&:hover": {
                            transform: "scale(1.05)",
                            backgroundColor: "#90a4ae",
                        },
                    }}
                    >
                        Annulla
                    </Button>
                    <Button onClick={handleConfirmReadAvviso} variant="contained"
                    sx={{
                        borderRadius: '10px',
                        width: '10em',
                        backgroundColor: "#213d72", 
                        color: "#ffffff", 
                        "&:hover": {
                            backgroundColor: "#1a315b", 
                            transform: "scale(1.05)",
                        },
                    }}
                    autoFocus
                    >
                        {t("Conferma")}
                    </Button>
                </DialogActions>
            </Dialog>

             {/* Dialog per inviare l'email al supporto */}
            <Dialog maxWidth="xs" fullWidth
                open={openSupportDialog}
                onClose={closeSupportDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle sx={{ fontWeight: 'bold', color: '#263F78', textAlign: 'center'}}>{t('Supporto')}</DialogTitle>
                    <DialogContent sx={{ display: 'flex', justifyContent: 'center' }}>
                        <DialogContentText sx={{ textAlign: 'center'}}>{t('Hai bisogno del supporto tecnico?')}</DialogContentText>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'center', mb:2}}>
                    <Button onClick={closeSupportDialog}
                    variant="contained"
                    sx={{
                        borderRadius: '10px',
                        width: '10em',
                        backgroundColor: "#b0bec5", 
                        color: "#ffffff", 
                        "&:hover": {
                            transform: "scale(1.05)",
                            backgroundColor: "#90a4ae",
                        },
                    }}
                    >
                        Annulla
                    </Button>
                    <Button onClick={handleSendEmailSupport} variant="contained"
                    sx={{
                        borderRadius: '10px',
                        width: '10em',
                        backgroundColor: "#213d72", 
                        color: "#ffffff", 
                        "&:hover": {
                            backgroundColor: "#1a315b", 
                            transform: "scale(1.05)",
                        },
                    }}
                    autoFocus
                    >
                        Conferma
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar
                open={openSnackbar}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                >
                <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
                    {message}
                </Alert>
            </Snackbar>

        </>
    );
};

export default NavBar;
